import { TextFieldVariants } from "@mui/material";
import SelectIdNameMultiple from "components/SelectIdNameMultiple";
import useLicenseFilterOptions from "hooks/useLicenseFilterOptions";
import { useIntl } from "react-intl";

type SelectDesignationMultipleProps = {
  value: string[];
  onChange: (v: string[]) => void;
  variant?: TextFieldVariants;
  disabled?: boolean;
};

const SelectDesignationMultiple = ({
  value,
  onChange,
  variant,
  disabled,
}: SelectDesignationMultipleProps) => {
  const { formatMessage: t } = useIntl();
  const { data, isFetching } = useLicenseFilterOptions();

  return (
    <SelectIdNameMultiple
      label={t({ id: "designation" })}
      options={data?.data?.designations ?? []}
      value={value}
      onChange={onChange}
      loading={isFetching}
      variant={variant}
      disabled={disabled}
    />
  );
};

export default SelectDesignationMultiple;
